import {Colors, Container, Divider} from "@bounce/shared/ui";
import React from "react";

const MenuItemDivider = () => {
  return (
    <Container fullWidth sx={{my: "7px"}}>
      <Divider
        fullWidth
        sx={{
          height: "2px",
          borderColor: Colors.primary._100,
          backgroundColor: Colors.primary._100,
        }}
      />
    </Container>
  );
};

export default MenuItemDivider;
